'use client';
import { jsx as _jsx } from "react/jsx-runtime";
import { ListSubheader, MenuItem, TextField } from '@mui/material';
import { noop } from 'lodash';
import { useState } from 'react';
export default function SelectField({ id = Math.random().toString(36).substring(7), options = [], defaultValue = '', value: valueProp = '', selectLabelAttribute = 'label', selectValueAttribute = 'value', defaultOptionLabel = '', onChange = noop, loading, label, ...props }) {
    const [value, setValue] = useState(defaultValue || valueProp);
    const handleChange = (event) => {
        setValue(event.target.value);
        onChange(event);
    };
    if (loading) {
        return null;
    }
    return (_jsx(TextField, { label: label, value: value, onChange: handleChange, select: true, ...props, children: options.map((option, i) => {
            if (option.header) {
                return _jsx(ListSubheader, { children: option.header }, i);
            }
            return (_jsx(MenuItem, { value: option[selectValueAttribute], disabled: option.disabled, children: option[selectLabelAttribute] }, i));
        }) }));
}
